import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

import {
  CouponsTable,
  GenerateCouponsForm,
  GenerationControlTable,
  RegisterPaymentTable,
  ExternalPaymentTable,
  ViewPaymentsTable,
  UpdateDebtTable,
  DebtDetailTable,
  DebtNotificationsTable,
  RegularizedPlansTable,
  CouponsMailsTable,
  SubscribersTable,
  LegalEntitiesTable,
  FireInsurance,
  RealStateTaxes,
  LifeInsurance,
  Layout,
  Habitat99Statistics,
  CollectingEntitiesStatistics,
  UsersTable,
  ProfilesTable,
  BranchesTable,
  ContractsTable,
  PlansTable,
  LoginForm,
  Home,
  ProjectManagementDashboard,
  TaskTemplatesTable,
  DashboardManagement,
  InvoiceQueryTable,
  LastInvoiceTable,
  DifferimentsTable,
  SessionTimeoutDialog,
  PageNotFound,
  SubcontractorsTable,
  MovementTypes,
  MovementConcepts,
  BankMovements,
  BankAccounts,
  BankProjectedReport,
  PaymentOrders,
  AuditLogs,
  ExchangeChecks,
  CashRetentions,
  DifferimentInvoices,
  PushNotificationsCenter,
  MobileNotificationsList,
} from './refactored-app/';

import { ProtectedRoute } from './refactored-app/';

import { useAuth } from './refactored-app/hooks/useAuth';

import { useCallback } from 'react';

function App() {
  const navigate = useNavigate();

  const { isAuthenticated: isLoggedIn, clearToken: clearZustandToken } = useAuth();

  const handleLogout = useCallback(() => {
    clearZustandToken();
    navigate('/');
  }, [navigate, clearZustandToken]);

  return (
    <>
      <SessionTimeoutDialog />
      {isLoggedIn ? (
        <Layout>
          <Routes>
            <Route
              path="/entidades/personas-juridicas"
              element={
                <ProtectedRoute>
                  <LegalEntitiesTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contratos"
              element={
                <ProtectedRoute>
                  <ContractsTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contrato/seguro-vida"
              element={
                <ProtectedRoute>
                  <LifeInsurance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contrato/seguro-incendio"
              element={
                <ProtectedRoute>
                  <FireInsurance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contrato/seguro-incendio/importar"
              element={
                <ProtectedRoute>
                  <FireInsurance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contrato/real-state-tax"
              element={
                <ProtectedRoute>
                  <RealStateTaxes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan/ver-planes/"
              element={
                <ProtectedRoute>
                  <PlansTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entidades/suscriptores"
              element={
                <ProtectedRoute>
                  <SubscribersTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/generar/generar-cupones"
              element={
                <ProtectedRoute>
                  <GenerateCouponsForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/generar/control-generacion"
              element={
                <ProtectedRoute>
                  <GenerationControlTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/cupones"
              element={
                <ProtectedRoute>
                  <CouponsTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/cupones/actualizar-deuda"
              element={
                <ProtectedRoute>
                  <UpdateDebtTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/cupones/detalle-mora"
              element={
                <ProtectedRoute>
                  <DebtDetailTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/cupones/comunicar-mora"
              element={
                <ProtectedRoute>
                  <DebtDetailTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/cupones/notificaciones-mora"
              element={
                <ProtectedRoute>
                  <DebtNotificationsTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/notificaciones/push"
              element={
                <ProtectedRoute>
                  <PushNotificationsCenter />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/notificaciones/mobile"
              element={
                <ProtectedRoute>
                  <MobileNotificationsList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/diferimientos/resumen"
              element={
                <ProtectedRoute>
                  <DifferimentsTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/diferimientos/facturas"
                element={
                  <ProtectedRoute>
                    <DifferimentInvoices />
                  </ProtectedRoute>
                }
              />
            <Route
              path="/cupon/estadisticas-habitat99"
              element={
                <ProtectedRoute>
                  <Habitat99Statistics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/cupones/planes-regulariza"
              element={
                <ProtectedRoute>
                  <RegularizedPlansTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/registrar/registrar-cobro"
              element={
                <ProtectedRoute>
                  <RegisterPaymentTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/registrar/cobros-externos"
              element={
                <ProtectedRoute>
                  <ExternalPaymentTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/registrar/ver-cobros"
              element={
                <ProtectedRoute>
                  <ViewPaymentsTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/registrar/ver-factura-afip"
              element={
                <ProtectedRoute>
                  <InvoiceQueryTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/registrar/ultima-factura-afip"
              element={
                <ProtectedRoute>
                  <LastInvoiceTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/impresion/cupones-mail"
              element={
                <ProtectedRoute>
                  <CouponsMailsTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/administracion/sucursales"
              element={
                <ProtectedRoute>
                  <BranchesTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/administracion/usuarios"
              element={
                <ProtectedRoute>
                  <UsersTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/administracion/perfiles"
              element={
                <ProtectedRoute>
                  <ProfilesTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/obra/seguimiento/proyectos"
              element={
                <ProtectedRoute>
                  <ProjectManagementDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/obra/seguimiento/dashboard-avance"
              element={
                <ProtectedRoute>
                  <DashboardManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/obra/seguimiento/plantillas"
              element={
                <ProtectedRoute>
                  <TaskTemplatesTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/subcontratistas"
              element={
                <ProtectedRoute>
                  <SubcontractorsTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/tipos-de-movimiento"
              element={
                <ProtectedRoute>
                  <MovementTypes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/conceptos-de-movimiento"
              element={
                <ProtectedRoute>
                  <MovementConcepts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/movimientos"
              element={
                <ProtectedRoute>
                  <BankMovements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/cheques-canje"
              element={
                <ProtectedRoute>
                  <ExchangeChecks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/retenciones-efectivo"
              element={
                <ProtectedRoute>
                  <CashRetentions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/cuentas"
              element={
                <ProtectedRoute>
                  <BankAccounts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/informe-proyectado"
              element={
                <ProtectedRoute>
                  <BankProjectedReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bancos/ordenes-de-pago"
              element={
                <ProtectedRoute>
                  <PaymentOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cupon/estadisticas-entidades-recaudadoras"
              element={
                <ProtectedRoute>
                  <CollectingEntitiesStatistics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/administracion/auditoria"
              element={
                <ProtectedRoute>
                  <AuditLogs />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <PageNotFound />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/home" replace />} />
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </>
  );
}

export default App;
